export default "__VITE_ASSET__d8786b25__"